
var id = "menu_scene";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"menu_scene\">\n<path d=\"M118.5,59.3H22.2C10,59.3,0,69.2,0,81.5v96.3C0,190,10,200,22.2,200h96.3c12.3,0,22.2-10,22.2-22.2V81.5\n\tC140.7,69.2,130.8,59.3,118.5,59.3z M125.9,177.8c0,4.1-3.3,7.4-7.4,7.4H22.2c-4.1,0-7.4-3.3-7.4-7.4V81.5c0-4.1,3.3-7.4,7.4-7.4\n\th96.3c4.1,0,7.4,3.3,7.4,7.4V177.8z\" />\n<path d=\"M148.1,29.6H51.9c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h96.3c4.1,0,7.4,3.3,7.4,7.4v96.3c0,4.1,3.3,7.4,7.4,7.4\n\tc4.1,0,7.4-3.3,7.4-7.4V51.9C170.4,39.6,160.4,29.6,148.1,29.6z M103.7,155.6H37c-4.1,0-7.4,3.3-7.4,7.4c0,4.1,3.3,7.4,7.4,7.4h66.7\n\tc4.1,0,7.4-3.3,7.4-7.4C111.1,158.9,107.8,155.6,103.7,155.6z\" />\n<path d=\"M177.8,0H81.5c-4.1,0-7.4,3.3-7.4,7.4s3.3,7.4,7.4,7.4h96.3c4.1,0,7.4,3.3,7.4,7.4v96.3c0,4.1,3.3,7.4,7.4,7.4\n\tc4.1,0,7.4-3.3,7.4-7.4V22.2C200,10,190,0,177.8,0z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
